<template>
    <v-layout column>
        <span class="title text-xs-left mb-2">Course Work</span>
        <v-divider class="grey"></v-divider>
        <br>
        <v-dialog v-model="deleteDialog" max-width="350" persistent>
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    <!-- <v-icon medium color="warning">warning</v-icon> -->
                    Delete Credit Note
                </v-card-title>
                <v-card-text class="text-xs-left">
                    Are you sure you want to delete this record?
                </v-card-text>
                <v-card-actions>
                    <v-flex layout row wrap>
                        <v-flex xs12 sm6 pl-3 pr-3 pb-3>
                            <v-btn class="error" block dark flat="flat" @click="deleteDialog = false">Cancel</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 pl-3 pr-3 pb-3>
                            <v-btn class="primary" block dark flat="flat" @click="deleteRecord()">Confirm</v-btn>
                        </v-flex>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="createClassroomDialog" max-width="850" persistent>
            <v-card>
                <v-card-title class="grey lighten-2">
                    <!-- <v-icon medium color="warning">warning</v-icon> -->
                    <span class="subheading"> Create Course Work </span>
                    <v-btn class="close" icon right flat="flat" @click="createClassroomDialog = false"><v-icon small >close</v-icon></v-btn>
                </v-card-title>
                <v-flex layout row wrap pt-2 pb-2 mb-4 text-xs-left text-sm-left text-md-center text-lg-center>

                    <v-flex layout row wrap pt-2 pb-2>
                        <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                            <v-text-field
                                    v-model="form.name" type="text" name="name" label="Name" box
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                            <v-text-field
                                    v-model="form.description" type="text" name="description" label="Description" box
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                            <v-text-field
                                    v-model="form.alias" type="text" name="alias" label="Classroom Name" box
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                            <v-text-field
                                    v-model="form.course_id" type="text" name="name" label="Classroom ID" box
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6 pr-2 pl-2 pt-2 pb-4>
                            <v-text-field
                                    v-model="form.topic_id" type="text" name="topic" label="Topic ID" box
                            ></v-text-field>
                        </v-flex>


                        <!--<v-flex xs6 pr-2 pl-2 pt-2 pb-4>-->
                        <!--<v-text-field-->
                        <!--v-model="form.password" type="text" name="password" label="Password" box-->
                        <!--&gt;</v-text-field>-->
                        <!--</v-flex>-->

                        <!--<v-flex xs6 pr-2 pl-2 pt-2 pb-4>-->
                        <!--<v-autocomplete :items="$store.getters.getUserTypes.sort()" label="User Role"-->
                        <!--item-text="name" item-value="id" placeholder=""-->
                        <!--v-model="form.role" box >-->

                        <!--</v-autocomplete>-->
                        <!--</v-flex>-->
                    </v-flex>

                </v-flex>
                <v-card-actions>
                    <v-flex xs12 layout row wrap>
                        <v-flex xs12 sm6 pl-2 pr-2 pb-2>
                            <v-btn class="error" block dark flat="flat" @click="createClassroomDialog = false">Cancel</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 pl-2 pr-2 pb-2>
                            <v-btn class="primary" block dark flat="flat" v-on:click="createCourseWork()">Ok</v-btn>
                        </v-flex>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>



        <v-card>
            <v-toolbar flat dense class="primary" dark>
                <v-text-field xs6 v-model="searchText" prepend-icon="search" label="Search" color="white" single-line clearable hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-btn  v-show="$store.state.auth.user.role!=4" dark class="primary darken-2" flat @click="updateCourseWork()"><v-icon class="pr-3">refresh</v-icon>Update Coursework</v-btn>
                <v-btn color="primary" dark class="mb-2" icon @click="getAll()"><v-icon>refresh</v-icon></v-btn>
            </v-toolbar>

            <v-data-table v-if="$store.state.classrooms.courseWork.headers" :headers="$store.state.classrooms.courseWork.headers"
                          :items="allItems" :loading="loading" :search="searchText" class="elevation-2" :total-items="total"
                          :rows-per-page-items="rows" :pagination.sync="pagination">
                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <tr @click="highlightDevice = props.item" :class="{'grey lighten-3':highlightDevice == props.item}">
                        <td v-for="(header, index) in $store.state.classrooms.courseWork.headers" :key="index" :class="'text-xs-'+header.align">
                            <span v-if="header.value != 'actions'">{{ props.item[header.value] }}</span>
                            <span v-else v-show="$store.state.auth.user.role!=4">
                <v-btn icon class="grey lighten-4" @click="edit(props.item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                                <!--<v-btn icon class="grey lighten-4" @click="deletePrompt(props.item)">-->
                                <!--<v-icon color="accent">delete</v-icon>-->
                                <!--</v-btn>-->
              </span>
                        </td>
                    </tr>
                </template>

            </v-data-table>
        </v-card>
    </v-layout>
</template>

<script>
    import ClassroomService from "@/services/ClassroomService";

    export default {
        name: "CourseWork",
        components: {},
        data() {
            return {
                searchText: null,
                highlightDevice: null,
                loading: false,
                loadingTime: 1000,
                deleteDialog: false,
                createClassroomDialog: false,
                selectedId: null,
                allItems:[],
                rows:[10,20,50,150,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
                pagination: {},
                total: 0,
                lastPage: 1,
                form: {
                    name: null,
                    description: null,
                    alias: null,
                    course_id: null,
                    topic_id: null,
                },
            };
        },
        watch: {
            pagination: {
                handler () {
                    if(this.pagination.page == 1 && this.lastPage == 1) {
                        console.log("First page handler");
                        // this.getAll();
                    } else if(this.pagination.page < this.lastPage)  {
                        this.getPrev();
                    } else {
                        this.getMore();
                    }
                },
                deep: true
            },
            async searchText(){
                try {
                    // var color = "info";
                    this.loading=true;
                    console.log('Search Watch');
                    console.log(this.searchText);
                    // const response = await InteractionService.getAll("", "", this.pagination.rowsPerPage, this.searchText);
                    // console.log(response);
                    // if (response.data.code > 200) {
                    //     color = "warning";
                    // } else if (response.data.result == 2000) {
                    //     this.$store.dispatch("setInteractions", response.data.data);
                    //     this.allItems=response.data.data;
                    //     this.total = response.data.total;
                    //     // this.convertDate()
                    // }
                    // this.loading = false;
                    // this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});
                    this.loading=false;
                } catch (err) {
                    console.log(err);
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {show: true, text: "Error occurred", color: "error", x: "left", timeout: 3000});
                }
            }
        },
        mounted() {
            this.getAll();
        },
        methods: {
            async createCourseWork(){
                try {
                    let color = "info";
                    this.loading = true;
                    console.log("Creating Course: ", this.form);

                    const response = await ClassroomService.createCourseWork(this.form);

                    // console.log("")

                    if (response.data.code > 200) {
                        color = "warning";
                    } else if (response.data.result == 2000) {
                        // this.$store.dispatch("setInteractions", response.data.data);
                        // this.allItems=response.data.data;
                        // this.total = response.data.total;
                        // this.convertDate()
                        console.log("Successful Process");
                    }
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});

                }catch (err) {
                    console.log(err);
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "left", timeout: 3000});
                }
                this.createClassroomDialog = false;
            },
            async createCourseWorkFromGSheet(){
                try {
                    let color = "info";
                    this.loading = true;
                    console.log("Mass Creating Course: ");

                    const response = await ClassroomService.createMassCourseWork();

                    if (response.data.code > 200) {
                        color = "warning";
                    } else if (response.data.result == 2000) {
                        console.log("Successful Process");
                    }
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "left", timeout: 3000});

                }catch (err) {
                    console.log(err);
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "left", timeout: 3000});
                }
                this.createClassroomDialog = false;
            },
            getPrev() {

            },

            deletePrompt: function(note){
                this.selectedId = note.id;
                this.deleteDialog = true;
            },
            async getAll() {
                try {
                    // console.log("User info: ", this.$store.state.auth.user);
                    this.loading = true;
                    console.log("Inside coursework GetAll");
                    var color = "info";
                    const response = await ClassroomService.getGSheetCourseWorkRecords();
                    // var response;
                    if(this.$store.state.auth.user.role === 2){
                        console.log("Regular admin found: ", this.$store.state.auth.user.email);
                        // response = await InteractionService.adminAll("", "", this.pagination.rowsPerPage, "", this.$store.state.auth.user.id);
                    } else {
                        console.log("Super Admin: ",  this.$store.state.auth.user.email);
                        // response = await InteractionService.getAll("", "", this.pagination.rowsPerPage, "");
                    }

                    // const customerResponse = await CustomerService.getAll("", "", this.pagination.rowsPerPage, "");
                    console.log(response);
                    // console.log(customerResponse);
                    // this.$store.dispatch("setCustomers", customerResponse.data.data);
                    if (response.data.code > 200) {
                        color = "warning";
                    } else if (response.data.result == 2000 && response.data.data) {
                        this.$store.dispatch("setInteractions", response.data.data);
                        this.allItems = response.data.data;
                        // this.total = response.data.total;
                        // console.log("totals", this.total);
                        this.loading = false;
                        this.convertDate();
                    }
                    this.$store.dispatch("setSnackbar", {
                        show: true,
                        text: response.data.message,
                        color: color,
                        x: "left",
                        timeout: 3000
                    });
                } catch (err) {
                    console.log(err);
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {
                        show: true,
                        text: "Error occured",
                        color: "error",
                        x: "left",
                        timeout: 3000
                    });
                }
            },
            async getMore() {
                try {

                } catch (err) {
                    console.log(err);
                    this.$store.dispatch("setSnackbar", {
                        show: true,
                        text: "Error occured",
                        color: "error",
                        x: "left",
                        timeout: 3000
                    });
                }
            },
            async updateCourseWork(){
                try {
                    let color = "info";
                    this.loading = true;
                    console.log("Updating coursework records");
                    this.$store.dispatch("setSnackbar", {show: true, text: "Updating Database", color: color, x: "right", timeout: 3000});

                    const response = await ClassroomService.updateCourseWorkRecords();

                    if (response.data.code > 200) {
                        color = "warning";
                    } else if (response.data.result == 2000) {
                        console.log("Successful Process");
                    }
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {show: true, text: response.data.message, color: color, x: "right", timeout: 3000});

                }catch (err) {
                    console.log(err);
                    this.loading = false;
                    this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "right", timeout: 3000});
                }
            },
            convertDate: function (){
                var date = null;
                for (var i=0; i<this.allItems.length;i++){
                    date = new Date(this.allItems[i].creation_time);
                    this.allItems[i].creation_time=date.toLocaleString();
                }
            },
        }
    };
</script>

<style scoped>

</style>